module.exports = __webpack_public_path__ + "static/media/14.cf81c8a8.svg";